import React, { useEffect } from 'react';
import Typography from '@material-ui/core/Typography';
import withStyles from '@material-ui/core/styles/withStyles';
import Page from 'Components/Page';
import { useForm } from 'react-hook-form';
import * as actions from 'Store/actions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Button from '@material-ui/core/Button';
import { withRouter } from 'react-router-dom';
import history from '../history';
import ItemReviewProduct from 'Components/ItemReviewProduct';
import ItemReviewTable from 'Components/ItemReviewTable';
import ItemDetails from 'Components/ItemDetails';

const pageStyles = theme => ({
  pageWrapper: {
    paddingLeft: '5%',
    paddingRight: '5%',
  },
  pageHeader: {
    marginBottom: 25,
  },
  itemOverview: {
    marginBottom: 120,
    [theme.breakpoints.down('sm')]: {
      marginBottom: 50,
    },
  },
  reviewProducts: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  reviewProduct: {
    display: 'flex',
    width: '50%',
    marginBottom: '90px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginBottom: '30px',
    },
  },
  reviewTableHeader: {
    fontSize: '26px',
    color: '#9e9e9e',
    fontFamily: "'Roboto', sans-serif",
    marginBottom: 0,
  },
  orderReviewTableContainer: {
    marginBottom: '40px',
  },
  checkoutButton: {
    marginBottom: '60px',
  },
  total: {
    fontWeight: 'bold',
  },
});

function ItemReview({ classes, itemDraft, saveItemDraftInfo, saveItemDraftOrder, productData, getProductData }) {
  const { register, handleSubmit, setValue, errors, watch, getValues } = useForm({
    mode: 'onChange',
    defaultValues: {
      areStickersOrdered: false,
      areDogTagsOrdered: false,
      areLuggageTagsOrdered: false,
      areBoneTagsOrdered: false,
      numStickersOrdered: 1,
      numDogTagsOrdered: 1,
      numLuggageTagsOrdered: 1,
      numBoneTagsOrdered: 1,
    },
  });

  const productsString = JSON.stringify(productData);

  useEffect(() => {
    itemDraft.order.forEach(order => {
      if (order.typeId === 1) setValue('areStickersOrdered', true, false);
      if (order.typeId === 2) setValue('areDogTagsOrdered', true, false);
      if (order.typeId === 3) setValue('areLuggageTagsOrdered', true, false);
      if (order.typeId === 4) setValue('areBoneTagsOrdered', true, false);
    });
    getProductData();
  }, [productsString, getProductData, itemDraft.order, setValue]);

  // This is important. Don't remove this.
  watch();

  const registerProductFields = products => {
    const formValues = getValues();

    products.forEach(({ key, checkboxName, selectName }) => {
      register({ name: checkboxName });
      register(
        { name: selectName },
        {
          validate: value => {
            if (value === '' && formValues[checkboxName]) {
              return `Specify how many ${key}`;
            }
          },
        },
      );
    });
  };

  registerProductFields(productData);

  const onSubmit = formData => {
    const orderedProducts = [];
    if (formData['areStickersOrdered']) {
      orderedProducts.push({
        typeId: 1,
        quantity: formData['numStickersOrdered'],
      });
    }

    if (formData['areDogTagsOrdered']) {
      orderedProducts.push({
        typeId: 2,
        quantity: formData['numDogTagsOrdered'],
      });
    }

    if (formData['areLuggageTagsOrdered']) {
      orderedProducts.push({
        typeId: 3,
        quantity: formData['numLuggageTagsOrdered'],
      });
    }

    if (formData['areBoneTagsOrdered']) {
      orderedProducts.push({
        typeId: 4,
        quantity: formData['numBoneTagsOrdered'],
      });
    }

    saveItemDraftOrder(orderedProducts);
    history.push('/add-item');
  };

  const calculateTotal = () => {
    const formData = getValues();
    let total = 0;
    if (formData['areStickersOrdered']) {
      let meta = productData.filter(product => product.productId === 1);
      let price = meta[0].price;
      let shipping = meta[0].shipping;
      let quantity = formData['numStickersOrdered'];
      total += price * quantity + shipping * quantity;
    }

    if (formData['areDogTagsOrdered']) {
      const meta = productData.filter(product => product.productId === 2);
      let price = meta[0].price;
      let shipping = meta[0].shipping;
      let quantity = formData['numDogTagsOrdered'];
      total += price * quantity + shipping * quantity;
    }

    if (formData['areLuggageTagsOrdered']) {
      let meta = productData.filter(product => product.productId === 3);
      let price = meta[0].price;
      let shipping = meta[0].shipping;
      let quantity = formData['numLuggageTagsOrdered'];
      total += price * quantity + shipping * quantity;
    }

    if (formData['areBoneTagsOrdered']) {
      let meta = productData.filter(product => product.productId === 4);
      let price = meta[0].price;
      let shipping = meta[0].shipping;
      let quantity = formData['numBoneTagsOrdered'];
      total += price * quantity + shipping * quantity;
    }

    return total.toFixed(2);
  };

  const renderReviewTable = () => {
    const formValues = getValues();
    const orderedProducts = [];
    if (formValues['areStickersOrdered']) {
      const stickersMeta = productData.filter(product => product.productId === 1);

      orderedProducts.push({
        ...stickersMeta[0],
        quantity: formValues['numStickersOrdered'],
      });
    }

    if (formValues['areDogTagsOrdered']) {
      const dogTagMeta = productData.filter(product => product.productId === 2);

      orderedProducts.push({
        ...dogTagMeta[0],
        quantity: formValues['numDogTagsOrdered'],
      });
    }

    if (formValues['areLuggageTagsOrdered']) {
      const lugTagMeta = productData.filter(product => product.productId === 3);

      orderedProducts.push({
        ...lugTagMeta[0],
        quantity: formValues['numLuggageTagsOrdered'],
      });
    }

    if (formValues['areBoneTagsOrdered']) {
      const BoneTagMeta = productData.filter(product => product.productId === 4);

      orderedProducts.push({
        ...BoneTagMeta[0],
        quantity: formValues['areBoneTagsOrdered'],
      });
    }

    return <ItemReviewTable products={orderedProducts} />;
  };

  const isCheckoutButtonDisabled = () => {
    const {
      areStickersOrdered,
      areDogTagsOrdered,
      areLuggageTagsOrdered,
      areBoneTagsOrdered,
      numStickersOrdered,
      numDogTagsOrdered,
      numLuggageTagsOrdered,
      numBoneTagsOrdered,
    } = getValues();
    if (
      (areStickersOrdered && numStickersOrdered > 0) ||
      (areDogTagsOrdered && numDogTagsOrdered > 0) ||
      (areLuggageTagsOrdered && numLuggageTagsOrdered > 0) ||
      (areBoneTagsOrdered && numBoneTagsOrdered > 0)
    ) {
      return false;
    } else {
      return true;
    }
  };

  return (
    <Page wrapperStyles={classes.pageWrapper}>
      <Typography variant="h1" className={classes.pageHeader}>
        Select a tag type(s)
      </Typography>
      {/* <ItemDetails
        name={itemDraft.info.name}
        message={itemDraft.info.message}
        phone={itemDraft.info.phone}
        imageUrl={itemDraft.info.images[0]}
        itemOverviewStyles={classes.itemOverview}
      /> */}
      <form onSubmit={handleSubmit(onSubmit)} className={classes.productsForm}>
        <div className={classes.reviewProducts}>
          {productData.map(
            ({
              checkboxName,
              label,
              numTags,
              dimensions,
              price,
              shipping,
              selectName,
              imageUrl,
              imageUrl2x,
              imageUrl3x,
              imageAltText,
            }) => {
              const formValues = getValues();

              return (
                <ItemReviewProduct
                  className={classes.reviewProduct}
                  checkboxName={checkboxName}
                  isChecked={formValues[checkboxName]}
                  onChangeCheckbox={e => {
                    setValue(checkboxName, e.target.checked, true);
                  }}
                  checkboxLabelText={label}
                  numTags={numTags}
                  dimensions={dimensions}
                  price={price}
                  shipping={shipping}
                  isQuantityDisabled={false}
                  selectName={selectName}
                  key={selectName}
                  onChangeSelect={e => setValue(selectName, e.target.value, true)}
                  selectValue={formValues[selectName]}
                  imageUrl={imageUrl}
                  imageUrl2x={imageUrl2x}
                  imageUrl3x={imageUrl3x}
                  imageAltText={imageAltText}
                />
              );
            },
          )}
        </div>

        <div className={classes.orderReviewTableContainer}>
          {/* <p className={classes.reviewTableHeader}>Order Review:</p>
            {renderReviewTable()} */}
          <p className={classes.total}>Total: ${calculateTotal()} (Free Shipping to the United States)</p>
        </div>

        <Button
          type="submit"
          variant="contained"
          color="primary"
          className={classes.checkoutButton}
          disabled={isCheckoutButtonDisabled()}
        >
          Continue
        </Button>
      </form>
    </Page>
  );
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      saveItemDraftInfo: actions.saveItemDraftInfo,
      saveItemDraftOrder: actions.saveItemDraftOrder,
      getProductData: actions.getProductData,
    },
    dispatch,
  );
}

function mapStateToProps({ itemDraft, productData }) {
  return {
    itemDraft,
    productData,
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withStyles(pageStyles)(ItemReview)));
